import { http } from './http';
import { apiHelper } from 'shared';

const controllerName = 'operators';

class Operators {
  async getUsingQueryFilter(queryFilter) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ name: queryFilter });

    const response = await http.get(`/${controllerName}${queryString}`);
    const items = response.data && response.data.items;

    return items;
  }

  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/${controllerName}/${queryString}`);
  }

  getById(id) {
    return http.get(`/${controllerName}/${id}`);
  }

  create(operator) {
    return http.post(`/${controllerName}`, operator);
  }

  delete(id) {
    return http.delete(`/${controllerName}/${id}`);
  }

  update(id, operator) {
    return http.put(`/${controllerName}/${id}`, operator);
  }
}

export const operators = new Operators();
